module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendaSummary"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('calendar-view', {
    attrs: {
      "setStartDate": _vm.setStartDate,
      "setEndDate": _vm.setEndDate,
      "setMonth": _vm.handleMonthChange,
      "monthToShow": _vm.selectedMonth,
      "conciliacaoData": _vm.conciliacaoData,
      "isLoadingData": _vm.isLoadingData,
      "categories": _vm.categories,
      "selectedCategory": _vm.selectedCategory,
      "setCategory": _vm.setCategory
    }
  })], 1), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('calendar-detail-box', {
    attrs: {
      "startDate": _vm.selectedStartDate,
      "endDate": _vm.selectedEndDate,
      "conciliacaoData": _vm.conciliacaoData,
      "parentLoadingData": _vm.isLoadingData,
      "filteredCategory": _vm.selectedCategory,
      "setCategory": _vm.setCategory
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-58825cfb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58825cfb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/conciliationSummary/calendarSummary.pug
// module id = 1416
// module chunks = 0